export const BuildInfo = {timestamp:1774385866000}
